// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mat-mdc-dialog-title {\n  margin: 0 0 10px;\n  display: block;\n}", "",{"version":3,"sources":["webpack://./src/app/alert-calendar-open/alert-calendar-open.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;AACJ","sourcesContent":[".mat-mdc-dialog-title {\n    margin: 0 0 10px;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
